import React from 'react'
import { useDispatch } from "react-redux";
import EditModal from "../common/EditModal";
import { updateBatch } from '../../redux/actions/admin/batchAction';

const EditBatch = ({id, name, duration, mode, startDate, endDate, refreshData}) => {
  const dispatch = useDispatch();
    const formFields = [
      {
        name: "name",
        label: "Batch & Class Name",
        value:  name,
        placeholder: "Batch & Class Name",
      },
      {
        name: "duration",
        label: "Batch & Class Duration",
        value: duration,
        placeholder: "Batch & Class Duration",
      },
      
      {
        name: "mode",
        label: "Batch & Class Mode",
        value: mode,
        placeholder: "Batch & Class Mode",
        type: "dropDown"
      },

      {
        name: "startDate",
        label: "Batch & Class Start Date",
        value: startDate,
        placeholder: "Select Start Date",
        type: "date",
      },
      {
        name: "endDate",
        label: "Batch & Class End Date",
        value: endDate,
        placeholder: "Select End Date",
        type: "date",
      },
    ];
  
    // Handle the course data update
    const handleUpdate = async (batchData) => {
      await dispatch(updateBatch(id, batchData));
      refreshData();
    };

    
  return (
    <>
    <EditModal
        title="Edit Batch & Class Details"
        formFields={formFields}
        onSubmit={handleUpdate}
        buttonName="Update Batch & Class"
        modelTitle="Are you sure you want to edit these Batch & Class details?"
        content="Please confirm to apply the changes mode to this Batch & Class."
        okText="Yes, Change"
        cancelText="No, Cancel"
        editButton = "Edit"
      />
    </>
  ) 
}

export default EditBatch